import app from '../../app';
import { KeyValueGambit } from '../IGambit';
export default class AuthorGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('core.lib.gambits.discussions.author.key', {}, true);
  }
  canonicalKey() {
    return 'author';
  }
  hint() {
    return app.translator.trans('core.lib.gambits.discussions.author.hint', {}, true);
  }
  filterKey() {
    return 'author';
  }
}
flarum.reg.add('core', 'common/query/discussions/AuthorGambit', AuthorGambit);